import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LayoutService } from '../../user-area-layout.service';
import { PanelBarItemModel } from '@progress/kendo-angular-layout';
import { MenuItems, MenuItem, LOCALIZED_MENU_ITEM_TITLE_SYMBOL } from '../../../../../../subsystem/types';
import { UserIdentity } from '../../../../../../security/types';
import { UserIdentityService } from '../../../../../../security/authentication/user-identity.service';
import { SubsystemManager } from '../../../../../../subsystem/subsystem-manager.service';

@Component({
    selector: 'mcb-portal-user-area-sidebar',
    templateUrl: 'sidebar.component.html'
})
export class PortalUserAreaSidebarComponent implements OnInit {
    public showSidebarClass = '';
    public showSidebarOnResponsiveClass = '';
    public showSidebarStatus = true; //true = defaultSidebar --- false = hideSidebar
    public grantedItems;
    private user: UserIdentity;
    titleSymbol = LOCALIZED_MENU_ITEM_TITLE_SYMBOL;
    // public expandMode: number = PanelBarExpandMode.Full;

    constructor(
        private router: Router,
        private userIdentityService: UserIdentityService,
        private subsystemManager: SubsystemManager,
        private layoutService: LayoutService,
    ) {
        this.user = userIdentityService.user;
        let menuItems: MenuItems = [];
        subsystemManager.subsystems
            .filter(ss => Array.isArray(ss.menuItems))
            .forEach(ss => menuItems = menuItems.concat(ss.menuItems));
        this.grantedItems = this.getGrantedItems(menuItems);
    }

    ngOnInit() {
        this.layoutService.onSideBarToggle.subscribe(showSidebar => {
            if (!showSidebar) {
                this.showSidebarClass = 'mcb-sidebar-hide';
            } else {
                this.showSidebarClass = '';
            }
            this.showSidebarOnResponsiveClass = '';
        });

        this.layoutService.onHeaderBarToggle.subscribe(openSideBar => {
            if (openSideBar) {
                this.showSidebarOnResponsiveClass = 'mcb-sidebar-open';
            } else {
                this.showSidebarOnResponsiveClass = '';
            }
            this.showSidebarClass = '';
        });
    }

    public routeChange(data) {
        const focused: PanelBarItemModel = data.filter(item => item.focused === true)[0];
        if (focused && focused.id !== '0') {
            this.router.navigate(['/user/sys/' + focused.id]);
        }
    }

    private getGrantedItems(items: MenuItems) {
        const grantedItems = [];
        items.forEach(x => {
            if (Array.isArray(x.children)) {
                const grantedChildren = this.getGrantedItems(x.children);
                if (grantedChildren.length > 0) {
                    const clonedItem: any = Object.assign({}, x);
                    clonedItem.title = x[LOCALIZED_MENU_ITEM_TITLE_SYMBOL];
                    clonedItem.id = '0'; // if we do not set id, silly Kendo will do!
                    clonedItem.children = grantedChildren;
                    grantedItems.push(clonedItem);
                }
            } else if (!x.permission || this.user.hasPermission(x.permission)) {
                const clonedItem: any = Object.assign({}, x);
                clonedItem.title = x[LOCALIZED_MENU_ITEM_TITLE_SYMBOL];
                clonedItem.id = x.path;
                grantedItems.push(clonedItem);
            }
        });

        return grantedItems;
    }

    showHideSidebar() {
        this.layoutService.toggleSideBar();
    }

    closeResponsiveSideBar() {
        this.layoutService.closeSideBar();
    }
}
